const ENQUIRE_HREF = "/get-in-touch#contact-us";

const TAGS = [
  "Tailored Charging Solutions",
  "Hassle-Free Installation",
  "2-Year Warranty",
  "48-Hour Response",
];

// NOTE: the cta-stats block (5000+ / 15+ / 24/7 repeated here) was
// commented out in the original HTML — same numbers already show in the
// proof band above it, so it's left out here too rather than duplicated.

export default function Cta() {
  return (
    <section className="cta-section" id="contact">
      <div className="cta-inner container">
        <p className="section-label">Get In Touch</p>
        <h2 className="section-title">Ready to deploy<br />fast charging?</h2>
        <p className="section-sub">
          Whether it's a single unit or a large-scale charging network, our team will help you
          scope, install, and go live fast.
        </p>

        <div className="cta-form">
          <a href={ENQUIRE_HREF} className="btn-primary" style={{ whiteSpace: "nowrap", textDecoration: "none" }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
            Get a Quote
          </a>
        </div>

        <div className="cta-tags">
          {TAGS.map((tag) => <span className="cta-tag" key={tag}>{tag}</span>)}
        </div>
      </div>
    </section>
  );
}
